function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Icon_ionic-md-exit",
  "data-name": "Icon ionic-md-exit",
  d: "M17.7,19.761l-1.7,1.7L9.95,15.4l6.056-6.056,1.7,1.7-3.149,3.149H26.3v2.422H14.613ZM6.922,4.5H23.879A2.429,2.429,0,0,1,26.3,6.922v4.845H23.879V6.922H6.922V23.879H23.879V19.034H26.3v4.845A2.429,2.429,0,0,1,23.879,26.3H6.922A2.429,2.429,0,0,1,4.5,23.879V6.922A2.429,2.429,0,0,1,6.922,4.5Z",
  transform: "translate(-4.2 -4.2)",
  fill: "#f86542",
  stroke: "#fff",
  strokeWidth: 0.6
});

var SvgIconExit = function SvgIconExit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22.401 22.401",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconExit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-exit.3321e48e.svg";
export { ForwardRef as ReactComponent };